import React from 'react';
import './Navibar.css'
import AccountPopover from './AccountPopover';
import { Link } from 'react-router-dom';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';


export default function NavibarCollasped({ setLoginSuccess, drawerNavigation = false, onNavigationToggle }) {
  const loggedInUser = sessionStorage.getItem("user_token");
  const foundUser = JSON.parse(loggedInUser);

  return (
    <nav className="navbar navibar" aria-label="Application header">
      <div className="container-fluid navibarContainer">
        <div className="navibarLeading">
          {drawerNavigation && (
            <button
              type="button"
              className="navibarMenuButton"
              aria-label="Open navigation"
              aria-controls="mvp-primary-navigation"
              aria-expanded="false"
              onClick={onNavigationToggle}
            >
              <MenuRoundedIcon />
            </button>
          )}

          <Link className="portalBrand portalBrand--compact" to="/" aria-label="Manual Vendor Portal home">
            <span className="portalBrandMark" aria-hidden="true">MV</span>
            <span className="portalBrandCopy">
              <span className="portalBrandName">Manual Vendor</span>
              <span className="portalBrandDescriptor">Portal</span>
            </span>
          </Link>
        </div>

        <div className="navibarActions">
          <div className="navibarWorkspace" aria-label="Current workspace">
            <span className="navibarWorkspaceLabel">
              {foundUser.role_capabilities?.all_modules_access === true ? 'Administration' : 'Vendor workspace'}
            </span>
            {foundUser.account_id && (
              <span className="navibarCompanyNumber">#{foundUser.account_id}</span>
            )}
          </div>
          <span className="navibarDivider" aria-hidden="true" />
          <AccountPopover setLoginSuccess={setLoginSuccess}/>
        </div>
      </div>
    </nav>
  )
}
